module.exports = __webpack_public_path__ + "img/orm_orocketsgame.cc282d9.png";